module.exports = __webpack_public_path__ + "1.4.15-unryo/img/offline-report-1.05a8e436.svg";